import { render, staticRenderFns } from "./FullScreenToggle.vue?vue&type=template&id=495d1d18"
import script from "./FullScreenToggle.vue?vue&type=script&lang=js"
export * from "./FullScreenToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports